export default __webpack_public_path__ + "5914f288720d7122e4eb70076cda31bb.png";